export const COLUMN = 'column';
export const NOT_PROVIDED = 'not_provided';
export const FORMULA = 'formula';
export const STATIC = 'static';
export const CUSTOM_VALUE = 'Custom value';
